/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PrivacyAndSafetyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACbElEQVR4nMVVy2oUURAdVyr4mqAb4x/4/IOAMdDSc6uqF7erZgKOMRrxBzJB8YdE42x07wsJMUTcGLfRiLtMoiCCTqS672Ruv8wQRBsKiurqepyqOl2r/c/HWjsGJDcApWtI1oD4m4rTHwPEM2HYqu8n8GEgvgfEW0Cy8ycxKD2DfFe/GSl4FE2fAZQVF6APyC8M8qwxctZaewQAjqqO2Lyp7xIfTUS8HIZ2fO/gJJ+G1fEvgPhKlb+JZCrxGfp/rEySwDKs3IOAPwfWnsr7NxrNk4Z4o+BPvDzRbh8qVoN8vxJrlKe1Wu2A7w8oD6pnwwv56sfcQPt+y7nK3gHyd5VELx/4zzSG9DLbpUNMg8gzE8llfw4wohiS9QY1JwzJKwftdb/drjPODvAd2CCt7IdBmQeQ0yoGuaM2D5KHg4oN8ZzreNHrQD6oMYziczmc37rEnZKZdVygN749jOKLrqO1oTPJthqttcczCUgvV3a06nyCpJu0+i3fjtg+4RJs/5UEBqWX6SBs1YsJHETGyIVRIQLiBbfCK9kOWpcKECXElQ7sVvWQuVM5ZJSufpOiwXec7ZHXbjzjsj5vIE/uZ02B+EuD+CqgvE5hja9lDk2xdMTVrzi0VYPyNRHi1fJDS4/UEG/qsDOYKuVWHxE/KaGKXQhLLno+P7OaEpQSVUnwjQG+I5Ed8lIp2aUrZseVcv2WTSRTpc6aBHkyQ9ck62UrXUwy7KSf/HCI5xBb54Ng+piK6ojN24DycveHg7y0Z3AfLt1zN/g9SI43FfMgCA6OFDzbTauurJjcCfL7wRYlOvGiIWkXtuVfP78BiFlHeFr5xocAAAAASUVORK5CYII=)
 */
export const PrivacyAndSafetyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-6.9 8.01a8.96 8.96 0 0 1-8.2 0l2.37-3.32a4.99 4.99 0 0 0 3.46 0l2.38 3.32ZM3 12c0 1.48.36 2.87.99 4.1l3.32-2.37a4.99 4.99 0 0 1 0-3.46L3.99 7.89A8.96 8.96 0 0 0 3 12Zm4.9-8.01a8.96 8.96 0 0 1 8.2 0L13.74 7.3a4.99 4.99 0 0 0-3.46 0L7.89 3.99ZM20 16.1a8.96 8.96 0 0 0 0-8.22l-3.32 2.38a4.99 4.99 0 0 1 0 3.46l3.32 2.38ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
